export default {
  //POC
  // domain: "proto-im-20210212.jp.auth0.com",
  // clientId: "IZysgjyanslRGlJb07sHCEgwMI9QE7Pb",
  // audience: "https://proto-im-20210212.jp.auth0.com/api/v2/",
  // IT
  // domain: "nomura-trinity-it1.nomura-trinity.auth0.com",
  // clientId: "Goec8QrKSxTIsepMd1U7P3jinO0JNjL8", //"N1ibzJc0MFzyM4foBjOrQ1HdSFaREIe6",
  // audience: "https://nomura-trinity-it1.nomura-trinity.auth0.com/api/v2/",
  // SIT
  //domain: "nomura-trinity-st1.nomura-trinity.auth0.com",
  //clientId: "v2ONvxKFY3tsuBXGsXnernDi8MeiZrti", //"N1ibzJc0MFzyM4foBjOrQ1HdSFaREIe6",
  //audience: "https://nomura-trinity-st1.nomura-trinity.auth0.com/api/v2/",
  // SI2
  //domain: "trinity-auth0-stg1.nomura.co.jp",
  //clientId: "hSrZ1qZwIu6z7iVHtjOzProCTQQOynpE",
  //audience: "https://nomura-trinity-stg1.nomura-trinity.auth0.com/api/v2/",
  // �{��
  domain: "id2.trynibus.com",
  clientId: "6FKHGjAt3wG9ohdkNWdR5bGn0lZTKy6s",
  audience: "https://nomura-trinity.jp.auth0.com/api/v2/",
  scope: "openid offline_access",

};
